// Define web component so existing <show-more-button> tags upgrade.
// Listener is attached at document level (delegated) so it survives
// AJAX innerHTML swaps from FacetFiltersForm.renderFilters.
customElements.get("show-more-button") ||
  customElements.define(
    "show-more-button",
    class extends HTMLElement {
      constructor() {
        super();
      }
    }
  );

(function () {
  if (window.__showMoreDelegated) return;
  window.__showMoreDelegated = true;

  document.addEventListener("click", function (e) {
    const button = e.target.closest('[id^="Show-More-"]');
    if (!button) return;

    const host = button.closest("show-more-button");
    const parentDisplay = button.closest(".parent-display");
    if (!parentDisplay) return;

    e.preventDefault();

    if (host) {
      host.querySelectorAll(".label-text").forEach((el) =>
        el.classList.toggle("hidden")
      );
    }

    parentDisplay.querySelectorAll(".show-more-item").forEach((el) =>
      el.classList.toggle("hidden")
    );

    const firstShown = parentDisplay.querySelector(
      ".show-more-item:not(.hidden) input"
    );
    if (firstShown) firstShown.focus();
  });
})();
